import React from 'react'
import { Moment } from 'moment'
import { DatePicker } from 'src/Libs/inputs/react-hook-form'
import { DatePickerProps } from '@mui/x-date-pickers'
import { DayMonthDateFormat, firstDayOfALeapYear, lastDayOfALeapYear, LeapYear } from 'src/Libs/dynamic-tariff-settings/constants'
import { makeStyles } from 'tss-react/mui'

type Props = {
  name: 'from' | 'to'
} & Omit<Partial<DatePickerProps<Moment, Moment>>, 'name' | 'type'>

const useStyles = makeStyles()(theme => ({
  /* Hide the day headers (M T W T F S S) in date picker */
  hideDayHeaders: {
    '& .MuiCalendarPicker-root .MuiTypography-caption': {
      display: 'none',
    },
  },
}))

/**
 * Date picker for dynamic tariff settings.
 * user can only select month and day.
 * year is fixed to 1972 (a leap year), so that all 366 days are available.
 */
const DynamicTariffDatePicker: React.FC<Props> = ({ name, ...props }) => {
  const { classes } = useStyles()

  const onTransform = (value: Moment | null): Moment | Date | null => {
    if (!value) return null
    const valueFixedToYear1972 = value.clone().year(LeapYear).hour(0).minute(0).second(0).millisecond(0)

    return valueFixedToYear1972?.toDate()
  }
  return (
    <DatePicker
      name={name}
      {...props}
      onTransform={onTransform}
      views={['day', 'month']}
      openTo="day"
      minDate={firstDayOfALeapYear}
      maxDate={lastDayOfALeapYear}
      inputFormat={DayMonthDateFormat}
      showToolbar={false}
      /* hide day headers in desktop */
      PopperProps={{ className: classes.hideDayHeaders }}
      /* hide headers in mobile */
      DialogProps={{ className: classes.hideDayHeaders }}
    />
  )
}

export default DynamicTariffDatePicker
